var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalkingRouteMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 23,
  fill: "#0074F2",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24.188 12.648c-.232-.427-.244-.99-.244-1.354s.012-.925.244-1.353c.22-.407.689-.941 1.507-.941.815 0 1.283.534 1.504.94.233.429.242.99.242 1.354s-.009.927-.242 1.354c-.221.406-.689.941-1.504.941-.818 0-1.286-.535-1.507-.941M20.57 32.024l1.15-13.283-1.663 1.441-.124 5.08c-.034.799-1.5.723-1.5-.034l-.156-4.85c-.003-.438.045-.936.368-1.284l3.32-4.008c.397-.48 1.105-.73 1.648-.739 1.02-.047 2.262.194 3.033.535.648.287 1.45.712 1.553 1.781l.508 4.732 2.998 3.26c.536.59-.56 1.568-1.157 1.144l-3.065-3.145a1.4 1.4 0 0 1-.157-.2l-.429 3.625 3.375 14.52h-1.965l-4.204-12.414c-.422 1.606-1.2 3.752-1.403 4.337-.194.552-.448 1.01-.82 1.404-.42.443-4.428 4.523-4.428 4.523l-1.22-1.28z"
}))));
export default SvgWalkingRouteMarker;